/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { setLang } from '../redux/langSlice';
import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";
import queryString from 'query-string';

export default function ({ onTermSelect, onOpenCookieSettings }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const lang = useSelector(state => state.langReducer.lang);
    const terms = useSelector(state => state.etcReducer?.terms || undefined);

    // const query = queryString.parse(location.search);

    // useEffect(() => {
    //     if(query?.termKey){
    //         onTermSelect(query?.termKey);
    //     }
    // }, [query]);
    const getTitle = (key) => {
        if (terms && terms[key]) {
            return terms[key][lang === 0 ? 'ko' : 'en']['sub'];
        } else {
            return '';
        }
    }

    const language_sample = ['한국어', 'English']
    const [selectLang, setSelectLang] = useState('한국어')
    const [languageDrop, setLanguageDrop] = useState(false);

    const { mbData } = useSelector((s) => s.usersReducer);

    const ChangeLang = (type) => {
        dispatch(loadingStart())
        setTimeout(() => {
            dispatch(setLang(type));

            if (mbData && mbData.idx > 0 && mbData.language) {
                let sender = {
                    id: mbData?.idx,
                    language: type === 0 ? 'ko' : 'en',
                };

                API.patch('user', sender, true);
            }

            dispatch(loadingEnd())
        }, 1000);
    };

    // ========================
    // 모달 관련 상태 및 로직
    // ========================
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedTermData, setSelectedTermData] = useState({ sub: '', content: '' });

    // 모달 열기
    const openModal = (termKey) => {
        if (!terms || !terms[termKey]) return;
        const currentLang = lang === 0 ? 'ko' : 'en';
        const sub = terms[termKey][currentLang].sub || '';
        const content = terms[termKey][currentLang].content || '';
        //onTermSelect(termKey);
        window.scrollTo(0, 0);
        navigate(routes.Term+"?termKey="+termKey);
        // setSelectedTermData({ sub, content });
        // setModalOpen(true);
    };

    // 모달 닫기
    const closeModal = () => {
        // setModalOpen(false);
        onTermSelect(null);
    };

    return (
        <>
            <div className="footer_main_box" style={{ background: '#000000' }}>
                <div className="footer_part_box">
                    <div className="logo_url_box">
                        <img src={require("../assets/icon/logo_col_white.svg").default} style={{ height: '24px' }} />
                        <div className="sns_box">
                            <a href="https://twitter.com/umodeler" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_x_icon.svg").default} />
                            </a>
                            <a href="https://www.instagram.com/_umodeler_/" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_instar_icon.svg").default} />
                            </a>
                            <a href="https://www.youtube.com/@UModeler" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_youtube_icon.svg").default} />
                            </a>
                            <a href="https://www.facebook.com/umodeler/" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_facebook.svg").default} />
                            </a>
                            <a href="https://www.linkedin.com/company/umodeler/" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_linkedin.svg").default} />
                            </a>
                            <a href="https://discord.gg/jvZmTkKbfF" target="_blank" rel="noopener noreferrer">
                                <img src={require("../assets/icon/footer_discord_icon.svg").default} />
                            </a>
                        </div>
                        <img src={require("../assets/icon/footer_unity.svg").default} />
                    </div>

                    <div className="footer_list_box">
                        <div className="footer_list top">
                            <p>{lang === 0 ? '기능' : 'Features'}</p>
                            <span onClick={() => { navigate(routes.Modeling) }}>{lang === 0 ? '스케치업 스타일 모델링' : 'SketchUp-Style Modeling'}</span>
                            <span onClick={() => { navigate(routes.PModeling) }}>{lang === 0 ? '폴리곤 모델링' : 'Polygon Modeling'}</span>
                            <span onClick={() => { navigate(routes.UV_Editing) }}>{lang === 0 ? 'UV 에디팅' : 'UV Editing'}</span>
                            <span onClick={() => { navigate(routes.Painting) }}>{lang === 0 ? '페인팅' : 'Painting'}</span>
                            <span onClick={() => { navigate(routes.Rigging) }}>{lang === 0 ? '리깅과 스키닝' : 'Rigging & Skinning'}</span>
                            <span onClick={() => { navigate(routes.Intergration) }}>{lang === 0 ? '유니티 통합환경' : 'Unity Integration'}</span>
                            <span onClick={() => { navigate(routes.Extension) }}>{lang === 0 ? 'Pro 확장 기능' : 'Pro Extension Features'}</span>
                            <span onClick={() => { navigate(routes.AI) }}>{lang === 0 ? '생성형 AI 활용' : 'Gen AI Utilization'}</span>
                            <span onClick={() => { navigate(routes.Library) }}>{lang === 0 ? '템플릿 라이브러리' : 'Template Library'}</span>
                        </div>

                        <div className="footer_list top">
                            <p>{lang === 0 ? '활용 분야' : 'Use Cases'}</p>
                            <span onClick={() => { navigate(routes.GameDev) }}>{lang === 0 ? '게임 개발' : 'Game Development'}</span>
                            <span onClick={() => { navigate(routes.Metaverse) }}>{lang === 0 ? '메타버스 제작' : 'Metaverse Creation'}</span>
                            {/* <span onClick={() => { navigate(routes.Indust) }}>{lang === 0 ? '산업 디자인' : 'Industrial Design'}</span> */}
                            <span onClick={() => { navigate(routes.Edu) }}>{lang === 0 ? '교육' : 'Education'}</span>
                        </div>

                        <div className="footer_list top">
                            <p>{lang === 0 ? '학습 및 지원' : 'Support'}</p>
                            <span
                                onClick={() => {
                                    if (lang === 0) {
                                        window.open('https://docs.umodeler.com/ko/docs/intro');
                                    } else {
                                        window.open('https://docs.umodeler.com/docs/intro');
                                    }
                                }}
                            >
                                {lang === 0 ? '공식 매뉴얼' : 'Official Manual'}
                            </span>
                            <span onClick={() => { navigate(routes.Support) }}>{lang === 0 ? '초심자 튜토리얼' : 'Tutorial'}</span>
                            <span
                                onClick={() => {
                                    window.open('https://discussions.unity.com/t/released-umodeler-x-model-rig-paint-and-ai-texture-within-unity-unity-vsp/659243')
                                }}
                            >
                                Unity Discussions
                            </span>
                            <span
                                onClick={() => {
                                    if (lang === 0) {
                                        window.open('https://docs.umodeler.com/ko/blog');
                                    } else {
                                        window.open('https://docs.umodeler.com/blog');
                                    }
                                }}
                            >
                                {lang === 0 ? '블로그' : 'Blog'}
                            </span>
                            <span
                                onClick={() => {
                                    window.open('https://discord.gg/qv54qkPdgy');
                                }}
                            >
                                {lang === 0 ? '디스코드' : 'Discord'}
                            </span>
                            <span
                                onClick={() => {
                                    window.open('https://www.youtube.com/@UModeler');
                                }}
                            >
                                {lang === 0 ? '유튜브' : 'YouTube'}
                            </span>
                        </div>

                        <div className="footer_list price btm sub">
                            <p>{lang === 0 ? '가격' : 'Pricing'}</p>
                            <span onClick={() => { navigate(routes.Price) }}>UModeler X Pro</span>
                        </div>

                        <div className="footer_list btm sub">
                            <p>{lang === 0 ? '참조 링크' : 'Reference Link'}</p>
                            <span onClick={() => openModal('Terms')}>{getTitle('Terms')}</span>
                            <span onClick={() => openModal('EULA')}>{getTitle('EULA')}</span>
                            <span onClick={() => openModal('Privacy')}>{getTitle('Privacy')}</span>
                            <span onClick={() => openModal('Cookies')}>{getTitle('Cookies')}</span>
                        </div>

                        <div className="footer_list price lang">
                            <p>{lang === 0 ? '언어' : 'Language'}</p>
                            <div
                                className={`footer_select ${languageDrop ? 'on' : ''}`}
                                onClick={() => {
                                    if (languageDrop) {
                                        setLanguageDrop(false)
                                    } else {
                                        setLanguageDrop(true)
                                    }
                                }}
                            >
                                <p>{lang === 0 ? '한국어' : 'English'}</p>
                                {languageDrop &&
                                    <div className="language_list">
                                        <p
                                            className={`${lang === 1 ? 'on' : ''}`}
                                            onClick={() => {
                                                ChangeLang(1)
                                            }}
                                        >
                                            English
                                        </p>
                                        <p
                                            className={`${lang === 0 ? 'on' : ''}`}
                                            onClick={() => {
                                                ChangeLang(0)
                                            }}
                                        >
                                            한국어
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer_text_box pc">
                    <p>Copyright ⓒ UModeler, Inc. All Rights Reserved</p>
                    <p>{lang === 0 ? '사업자등록번호 : 813-88-01285 | 통신판매업 신고번호 : 제 2025-서울강남-01463 호 | 대표 : 황재식 | 서울특별시 강남구 강남대로132길 59, 5층' : 'Business Number: 813-88-01285 | Mail order sales approval number : 2025-Seoul Gangnam-01463 | CEO: Jaesik Hwang | 5F, 59, Gangnam-daero 132-gil, Gangnam-gu, Seoul, Republic of Korea'}</p>
                    <p>{lang === 0 ? '문의' : 'Contact'} : contact.support@umodeler.com</p>
                </div>

                <div className="footer_text_box mobile">
                    <p>
                        Copyright ⓒ UModeler, Inc. All Rights Reserved
                    </p>
                    <p>{lang === 0 ? '사업자등록번호 : 813-88-01285 | 통신판매업 신고번호 : 제 2025-서울강남-01463 호 | 대표 : 황재식' : 'Business Number: 813-88-01285 | Mail order sales approval number : 2025-Seoul Gangnam-01463 | CEO: Jaesik Hwang'}</p>
                    <p>{lang === 0 ? '서울특별시 강남구 강남대로132길 59, 5층' : '5F, 59, Gangnam-daero 132-gil, Gangnam-gu, Seoul, Republic of Korea'}</p>
                    <p>contact.support@umodeler.com</p>
                </div>
            </div>

            {modalOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0,0,0,0.5)',
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={closeModal}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '32px',
                            gap: '32px',
                            width: '480px',
                            height: '480px',
                            background: '#FFFFFF',
                            borderRadius: '20px',
                            position: 'relative',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                height: '24px',
                            }}
                        >
                            <h3
                                style={{
                                    fontFamily: 'Pretendard',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '24px',
                                    color: '#121316',
                                    margin: 0,
                                }}
                            >
                                {selectedTermData.sub}
                            </h3>
                            <img src={require("../assets/images/exit-icon.svg").default} 
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    borderRadius: '4px',
                                }}
                                onClick={closeModal}
                            />
                        </div>

                        {/* 본문 (왼쪽 정렬) */}
                        <div
                            style={{
                                width: '100%',
                                flex: 1, // 남은 공간 모두 사용
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '19px',
                                color: '#121316',
                                overflowY: 'auto',
                                textAlign: 'left', // 왼쪽 정렬
                            }}
                            dangerouslySetInnerHTML={{ __html: selectedTermData.content }}
                        />
                    </div>
                </div>
            )}

            <div style={{ 
                background: '#000000',                
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',           // 너비 100% 추가
                position: 'relative',    // 상대 위치
                zIndex: 1000            // 다른 요소들 위에 표시
            }}>
                <button
                    onClick={onOpenCookieSettings}
                    style={{
                        background: '#000000',
                        color: '#999999',
                        fontSize: '12px',
                        border: 'none',
                        cursor: 'pointer',
                        textAlign: 'center',
                        fontFamily: 'Pretendard',
                        fontWeight: '400',
                        padding: '0px 0px',
                        width: '100%',
                        maxWidth: '1200px',
                        marginTop: '-60px'
                    }}
                >
                    {lang === 0 ? '개인정보 및 쿠키 설정' : 'Privacy & Cookie Settings'}
                </button>
            </div>
        </>
    );
}